/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Coordinate
 */
export interface Coordinate {
    /**
     * 
     * @type {string}
     * @memberof Coordinate
     */
    lng: string;
    /**
     * 
     * @type {string}
     * @memberof Coordinate
     */
    lat: string;
}

export function CoordinateFromJSON(json: any): Coordinate {
    return CoordinateFromJSONTyped(json, false);
}

export function CoordinateFromJSONTyped(json: any, ignoreDiscriminator: boolean): Coordinate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lng': json['lng'],
        'lat': json['lat'],
    };
}

export function CoordinateToJSON(value?: Coordinate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lng': value.lng,
        'lat': value.lat,
    };
}


